import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {of} from 'rxjs';
import {environment} from '../environments/environment';

const apiCalendarInfo = environment.apiCalendarData;
const apiCreateProject = environment.apiCreateProject;
const apiTextToVideoQueue = environment.apiTextToVideoQueue;

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  isAuthenticated = false;

  constructor(private http: HttpClient) {
  }

  getEvents() {
    return this.http.get(apiCalendarInfo);
    // return of(this.items);
  }

  setAuthenticated(value) {
    this.isAuthenticated = value;
  }

  getAuthenticated() {
    return this.isAuthenticated;
  }

  createProject(project_id) {
    return this.http.post(apiCreateProject + project_id, {project_id});
  }

  sendToQueue(text) {
    return this.http.post(apiTextToVideoQueue, {text});
  }
}
